import React from 'react';
import { availableCases } from '../data/casesData';

const CaseSelector = ({ selectedCase, onCaseSelect }) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-xl border border-gray-200 hover:shadow-2xl transition-shadow duration-300" style={{ display: 'flex', flexDirection: 'column', gridRow: '1', height: '100%' }}>
      <div className="flex items-center gap-3 mb-4" style={{ flexShrink: 0 }}>
        <div className="w-2 h-8 rounded-full" style={{ backgroundImage: 'linear-gradient(to bottom, #E78E42, #EAC144)' }}></div>
        <h3 className="text-2xl font-bold" style={{ color: '#000755' }}>Optimization Cases</h3>
      </div>
      <p className="text-gray-600 mb-4 text-sm" style={{ flexShrink: 0 }}>
        Select a case to view manufacturing locations and cost analysis
      </p>
      <div className="space-y-3 overflow-y-scroll overflow-x-visible pr-2"
           style={{
             flex: '1 1 0',
             minHeight: 0,
             scrollbarWidth: 'thin',
             scrollbarColor: '#E78E42 #f3f4f6'
           }}>
        {Object.entries(availableCases).map(([caseKey, caseData]) => (
          <div
            key={caseKey}
            className={`p-4 border-2 rounded-xl cursor-pointer transition-all duration-200 ${
              selectedCase === caseKey
                ? 'shadow-lg'
                : 'border-gray-200 hover:shadow-md'
            }`}
            style={
              selectedCase === caseKey
                ? { borderColor: '#E78E42', backgroundImage: 'linear-gradient(to bottom right, rgba(231, 142, 66, 0.1), rgba(234, 193, 68, 0.1))' }
                : { borderColor: '#e5e7eb' }
            }
            onMouseEnter={(e) => {
              if (selectedCase !== caseKey) {
                e.currentTarget.style.borderColor = '#E78E42';
              }
            }}
            onMouseLeave={(e) => {
              if (selectedCase !== caseKey) {
                e.currentTarget.style.borderColor = '#e5e7eb';
              }
            }}
            onClick={() => onCaseSelect(caseKey)}
          >
            <div className="flex items-start justify-between">
              <h4 className="font-bold flex-1" style={{ color: '#000755' }}>{caseData.title}</h4>
              {selectedCase === caseKey && (
                <svg className="w-6 h-6" style={{ color: '#E78E42' }} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <div className="mt-3 space-y-1.5">
              {caseData.manufacturingSteps.map((step, idx) => (
                <div key={idx} className="flex items-center gap-2 text-sm">
                  <span className="text-gray-500 min-w-[100px]">{step.step}:</span>
                  <span className="flex-1 font-semibold text-gray-700 bg-white px-3 py-1 rounded-lg border" style={{ borderColor: '#E78E42' }}>
                    {step.location}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseSelector;